import React from 'react';
import { HEX_ALPHA } from '../../utils/constants';
import { getText } from '../../utils/functions';
import { useIcons } from '../../utils/hooks';
import BgImg from '../basicComponents/BgImg';

/**
 * Regular NavBar for any screen except Home
 */

function NavBar({
	sections = [],
	translate,
	routing,
	setRouting,
	bgImg,
	colors,
	classNameDIV = `max-w-screen-2xl md:m-auto font-lato opacity-90 hidden md:grid grid-cols-${sections?.length}`,
}) {
	/* Icon hook */
	const { Triangle } = useIcons(colors);

	/* Default values for the styles */
	const defaultStyleDIV = {
		color: colors.secondary,
	};

	return <BgImg
		id='ShowcaseNavBar'
		img={bgImg}
		color={colors?.primary}
		classNameBG = 'w-full z-40 bg-cover sticky top-0'
	>
		<div
			className={classNameDIV}
			style={defaultStyleDIV}>
			{sections.map(section => (
				<Section
					key={section.value}
					colors={colors}
					Icon={Triangle}
					currentSection={routing}
					onClick={setRouting}
					section={section}
					translate={translate}
				/>
			))}
		</div>
	</BgImg>;
}

function Section({
	section,
	currentSection,
	colors,
	Icon,
	translate,
	onClick,

	/* OPTIONAL PROPS */
	classNameBTN = 'relative flex flex-col items-center focus:outline-none',
	classNameIMG = 'absolute pb-1 bottom-0 w-10 h-6 transform rotate-180',
	classNameSPAN = 'w-full mb-5 mt-5 align-text-bottom text-xl',
}) {
	/* Variable that checks if any point of the component is being hovered so style can be applied to the Box */
	const [hover, setHover] = React.useState(false);

	/* Default values for the styles */
	const defaultStyleSECTION = {
		backgroundColor: hover && colors?.primary,
		transition: 'all 200ms ease-in',
	};
	const defaultStyleICON = {
		fill: colors?.secondary,
	};
	const defaultStyleTEXT = {
		color: currentSection === section.value ? colors?.secondary : `${colors?.secondary}${HEX_ALPHA[90]}`,
		fontWeight: currentSection === section.value ? 'bold' : '',
	};

	/* Mouseover Styling */
	const onMouseOver = () => setHover(true);
	const onMouseLeave = () => setHover(false);

	return <button
		className={classNameBTN}
		style={defaultStyleSECTION}
		onClick={() => onClick(section.value)}
		onMouseOver={onMouseOver}
		onMouseLeave={onMouseLeave}
	>
		{section.value === currentSection && Icon
		&& Icon({
			className: classNameIMG,
			style: defaultStyleICON
		})
		}
		<span
			className={classNameSPAN}
			style={defaultStyleTEXT}
		>
			{getText(section, translate)}
		</span>
	</button>;
}

export default NavBar;
